<template>
    <div>
        <h2>This is Nursing Body Section</h2>
    </div>
</template>
  
<script>
  export default {
    name: 'NursingBody'
  }
</script>
  
<style scoped>
 
</style>